// Garden & Decorations data - extracted from game data
// Structure: levels arrays use compact format [level, stat1, stat2, ...]

export const gardenDecorations = [
  {
    key: 'mirage',
    name: 'Mirage',
    type: 'premium',
    statNames: [
      'Reduce Enemy Troops HP and increase Damage dealt by Archers and Mages for 15 seconds',
      'Attack boost',
      'Cross realm dmg'
    ],
    maxLevel: 13,
    levels: [
      [1, '3 / 1.5', null, null],
      [2, '4.5 / 2.2', null, null],
      [3, '6 / 2.9', null, null],
      [4, '7.5 / 3.6', null, null],
      [5, '9 / 4.3', null, null],
      [6, '10.5 / 5', 5, null],
      [7, '12 / 5.7', 5, null],
      [8, '13.5 / 6.4', 5, null],
      [9, '15 / 7.3', 5, null],
      [10, '16.5 / 8', 5, null],
      [11, '18 / 8.8', 5, null],
      [12, '19.5 / 9.6', 5, 2.5],
      [13, '21 / 10.4', 5, 2.5]
    ]
  },
  {
    key: 'poseidon_warship',
    name: "Poseidon's Warship",
    type: 'premium',
    statNames: [
      'Increase Attack and Damage of Archers and Mages for 15s (25s in Cross-Realm)',
      'Attack boost',
      'Cross realm dmg'
    ],
    maxLevel: 13,
    levels: [
      [1, '3 / 1.5', null, null],
      [2, '4.5 / 2.2', null, null],
      [3, '6 / 2.9', null, null],
      [4, '7.5 / 3.6', null, null],
      [5, '9 / 4.3', null, null],
      [6, '10.5 / 5', 5, null],
      [7, '12 / 5.7', 5, null],
      [8, '13.5 / 6.4', 5, null],
      [9, '15 / 7.3', 5, null],
      [10, '16.5 / 8', 5, null],
      [11, '18 / 8.8', 5, null],
      [12, '19.5 / 9.6', 5, 2.5],
      [13, '21 / 10.4', 5, 2.5]
    ]
  },
  {
    key: 'candy_castle',
    name: 'Candy Castle',
    type: 'premium',
    statNames: [
      'Increase Attack of Troops and bonus Damage against Troops with Shields',
      'Attack boost',
      'Cross realm dmg'
    ],
    maxLevel: 13,
    levels: [
      [1, '2.5 / 2.5', null, null],
      [2, '3.7 / 3.7', null, null],
      [3, '4.9 / 4.9', null, null],
      [4, '6.1 / 6.1', null, null],
      [5, '7.3 / 7.3', null, null],
      [6, '8.5 / 8.5', 5, null],
      [7, '9.7 / 9.7', 5, null],
      [8, '10.9 / 19.3', 5, null],
      [9, '12.2 / 12.2', 5, null],
      [10, '13.5 / 13.5', 5, null],
      [11, '14.8 / 14.8', 5, null],
      [12, '16.1 / 16.1', 5, 2.5],
      [13, '17.4 / 17.4', 5, 2.5]
    ]
  },
  {
    key: 'countryside_party',
    name: 'Countryside Party',
    type: 'premium',
    statNames: [
      'Reduce Damage Bonus of enemy Archers, Mages, and Angels + increase HP of Front Row Troop',
      'HP boost',
      'Cross realm dmg taken reduction'
    ],
    maxLevel: 13,
    levels: [
      [1, '1.8 / 2', null, null],
      [2, '2.7 / 3', null, null],
      [3, '3.6 / 4', null, null],
      [4, '4.5 / 5', null, null],
      [5, '5.4 / 6', null, null],
      [6, '6.3 / 7', 5, null],
      [7, 7.2, 5, null],
      [8, 8.1, 5, null],
      [9, 9, 5, null],
      [10, '9.9 / 11', 5, null],
      [11, '10.8 / 12', 5, null],
      [12, '11.7 / 13', 5, 2.5],
      [13, '12.6 / 14', 5, 2.5]
    ]
  },
  {
    key: 'love_in_the_city',
    name: 'Love in the City',
    type: 'premium',
    statNames: [
      'Increase Attack of Mages, Archers, and Angels + reduce Damage Reduction of enemy Cavalry and Infantry (first 10s)',
      'Attack boost',
      'Cross realm dmg'
    ],
    maxLevel: 13,
    levels: [
      [1, '2 / 1.8', null, null],
      [2, '3 / 2.7', null, null],
      [3, '4 / 3.6', null, null],
      [4, '5 / 4.5', 4, null],
      [5, '6 / 5.4', 4, null],
      [6, '7 / 6.3', 4, null],
      [7, '8 / 7.2', 4, null],
      [8, '9 / 8.1', 4, 2.5],
      [9, '10 / 9', 4, 2.5],
      [10, '11 / 9.9', 4, 2.5],
      [11, '12 / 10.8', 4, 2.5],
      [12, '13 / 11.7', 4, 2.5],
      [13, '14 / 12.6', 4, 2.5]
    ]
  },
  {
    key: 'star_collection',
    name: 'Star Collection',
    type: 'premium',
    statNames: [
      'Front Row Troop gets reduced Damage taken + reduced Damage from Angels',
      '5% HP boost',
      'Cross realm dmg taken reduced'
    ],
    maxLevel: 13,
    levels: [
      [1, '1.5 / 1.5', null, null],
      [2, '2.2 / 2.2', null, null],
      [3, '2.9 / 2.9', null, null],
      [4, '3.6 / 3.6', null, null],
      [5, '4.3 / 4.3', null, null],
      [6, '5 / 5', 5, null],
      [7, '5.7 / 5.7', 5, null],
      [8, '6.4 / 6.4 ', 5, null],
      [9, '7.2 / 7.2', 5, null],
      [10, '8 / 8', 5, null],
      [11, '8.8 / 8.8', 5, null],
      [12, '9.6 / 9.6', 5, 2.5],
      [13, '10.4 / 10.4', 5, 2.5]
    ]
  },
  {
    key: 'leviathan_magic_bottle',
    name: "Leviathan's Magic Bottle",
    type: 'premium',
    statNames: [
      'Increase Attack of Troops + Rage effect stacks Archers/Mages Damage per 10% Troops lost (up to 4x)',
      'HP boost',
      'Cross realm dmg taken reduced'
    ],
    maxLevel: 13,
    levels: [
      [1, '2.5 / 0.6', null, null],
      [2, '/ 0.9', null, null],
      [3, '/ 1.2', null, null],
      [4, '/ 1.5', null, null],
      [5, '/ 1.8', null, null],
      [6, '/ 2.1', 5, null],
      [7, '/ 2.4', 5, null],
      [8, '10 / 2.7', 5, null],
      [9, '11.2 / 3', 5, null],
      [10, '12.5 / 3.3', 5, null],
      [11, '13.7 / 3.6', 5, null],
      [12, '14.9 / 3.9', 5, 2.5],
      [13, '16.2 / 4.2', 5, 2.5]
    ]
  },
  {
    key: 'christmas_tale',
    name: 'Christmas Tale',
    type: 'premium',
    statNames: [
      'Increase Attack of Back Row Troop after attacking same target (stacks up to 3x, clears on switch)',
      'Attack boost',
      'Cross realm dmg'
    ],
    maxLevel: 13,
    levels: [
      [1, 3, null, null],
      [2, 4, null, null],
      [3, 5, null, null],
      [4, 6, 4, null],
      [5, 7, 4, null],
      [6, 8, 4, null],
      [7, 9, 4, null],
      [8, 10, 4, 2.5],
      [9, 11, 4, 2.5],
      [10, 12, 4, 2.5],
      [11, 13, 4, 2.5],
      [12, 14, 4, 2.5],
      [13, 15, 4, 2.5]
    ]
  },
  {
    key: 'dragon_guard',
    name: 'Dragon Guard',
    type: 'premium',
    statNames: [
      'For every 40,000 soldiers, increase Attack of Troops (up to max cap)',
      'Attack boost',
      'Cross realm dmg'
    ],
    maxLevel: 13,
    levels: [
      [1, '1 / 5', null, null],
      [2, '1.5 / 7.5', null, null],
      [3, '2 / 10', null, null],
      [4, '2.5 / 12.5', null, null],
      [5, '3 / 15', null, null],
      [6, '3.5 / 17.5', 5, null],
      [7, '4 / 20', 5, null],
      [8, '4.5 / 22.59', 5, null],
      [9, '5 / 25', 5, null],
      [10, '5,5 / 27.5', 5, null],
      [11, '6 / 30', 5, null],
      [12, '6.5 / 32.5', 5, 2.5],
      [13, '7 / 35', 5, 2.5]
    ]
  },
  {
    key: 'phantom_playground',
    name: 'Phantom Playground',
    type: 'premium',
    statNames: [
      'Infantry, Cavalry, and Angels get reduced Damage taken + reduce Attack effect of enemy soldiers',
      'HP boost',
      'Cross realm dmg taken reduced'
    ],
    maxLevel: 1,
    levels: [[1, '1.5 / 1.5', null, null]]
  },
  {
    key: 'castle_in_the_sky',
    name: 'Castle in the Sky',
    type: 'premium',
    statNames: [
      'Increase HP of Front Row Troop + reduce their Damage taken (first 10s)',
      'HP boost',
      'Cross realm dmg taken reduced'
    ],
    maxLevel: 1,
    levels: [[1, '1.5 / 1.5', null, null]]
  },
  {
    key: 'dune_pavilion',
    name: 'Dune Pavilion',
    type: 'normal',
    statNames: ['Hp boost', 'Max wounded', 'Cross realm troops HP'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'island_adventure',
    name: 'Island Adventure',
    type: 'normal',
    statNames: ['Attack boost', 'Max wounded', 'Cross-Realm Attack Boost'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'pumpkin_cart',
    name: 'Pumpkin Cart',
    type: 'normal',
    statNames: ['Attack boost', 'Max wounded', 'Cross-Realm Attack Boost'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'panda_courtyard',
    name: 'Panda Courtyard',
    type: 'normal',
    statNames: ['Attack boost', 'Max wounded', 'Cross-Realm Attack Boost'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'pandora_box',
    name: 'Pandora Box',
    type: 'normal',
    statNames: ['Hp boost', 'Max wounded', 'Cross realm troops HP'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'magic_house',
    name: 'Magic House',
    type: 'normal',
    statNames: ['Hp boost', 'Max wounded', 'Cross realm troops HP'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'spring_fishing',
    name: 'Spring Fishing',
    type: 'normal',
    statNames: ['Attack boost', 'Max wounded', 'Cross-Realm Attack Boost'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'romantic_date',
    name: 'Romantic Date',
    type: 'normal',
    statNames: ['Hp boost', 'Max wounded', 'Cross realm troops HP'],
    maxLevel: 15,
    levels: [
      [1, 2, null, null],
      [2, 2.5, null, null],
      [3, 3, null, null],
      [4, 3.5, 1500, null],
      [5, 4, 1500, null],
      [6, 4.5, 1500, null],
      [7, 5, 1500, null],
      [8, 5.5, 1500, 2.5],
      [9, 6, 1500, 2.5],
      [10, 6.6, 1500, 2.5],
      [11, 7.2, 1500, 2.5],
      [12, 7.9, 1500, 2.5],
      [13, 8.6, 1500, 2.5],
      [14, 9.3, 1500, 2.5],
      [15, 10, null, null]
    ]
  },
  {
    key: 'garden_cart',
    name: 'Garden Cart',
    type: 'normal',
    statNames: ['Attack boost', 'Max wounded', 'Cross-Realm Attack Boost'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'christmas_carol',
    name: 'Christmas Carol',
    type: 'normal',
    statNames: ['Hp boost', 'Max wounded', 'Cross realm troops HP'],
    maxLevel: 2,
    levels: [
      [1, 2, null, null],
      [2, 2.5, null, null]
    ]
  },
  {
    key: 'exotic_charm',
    name: 'Exotic Charm',
    type: 'normal',
    statNames: ['Attack boost', 'Max wounded', 'Cross-Realm Attack Boost'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'griffin_guard',
    name: 'Griffin Guard',
    type: 'normal',
    statNames: ['Hp boost', 'Max wounded', 'Cross realm troops HP'],
    maxLevel: 24,
    levels: [
      [1, 2, null, null],
      [2, 2.8, null, null],
      [3, 3.6, null, null],
      [4, 4.4, null, null],
      [5, 5.2, null, null],
      [6, 6, 2000, null],
      [7, 7, 2000, null],
      [8, 8, 2000, null],
      [9, 9, 2000, null],
      [10, 10, 2000, null],
      [11, 11, 2000, null],
      [12, 12, 2000, 2.5],
      [13, 13, 2000, 2.5],
      [14, 14, 2000, 2.5],
      [15, 15, 2000, 2.5],
      [16, 16, 2000, 2.5],
      [17, 17, 2000, 2.5],
      [18, 18, 2000, 2.5],
      [19, 19, 2000, 2.5],
      [20, 20, 2000, 2.5],
      [21, 21, 2000, 2.5],
      [22, 22, 2000, 2.5],
      [23, 23, 2000, 2.5],
      [24, 24, 2000, 2.5]
    ]
  },
  {
    key: 'desert_boat',
    name: 'Desert Boat',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'pirate_treasure',
    name: 'Pirate Treasure',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'troublemaking_ghost',
    name: 'Troublemaking Ghost',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'greenery_panda',
    name: 'Greenery Panda',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'bay_tree',
    name: 'Bay Tree',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'rabbit_tea_cup',
    name: 'Rabbit Tea Cup',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'windmill',
    name: 'Windmill',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'cherry_tree',
    name: 'Cherry Tree',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 16,
    levels: [
      [1, 1.2],
      [2, 1.3],
      [3, 1.4],
      [4, 1.5],
      [5, 1.6],
      [6, 1.7],
      [7, 1.8],
      [8, 1.9],
      [9, 2],
      [10, 2.2],
      [11, 2.4],
      [12, 2.6],
      [13, 2.8],
      [14, 3],
      [15, 3.2],
      [16, 3.4]
    ]
  },
  {
    key: 'midsummer_night_dreams',
    name: 'Midsummer Night Dreams',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'christmas_tree',
    name: 'Christmas Tree',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 16,
    levels: [
      [1, 1.2],
      [2, 1.3],
      [3, 1.4],
      [4, 1.5],
      [5, 1.6],
      [6, 1.7],
      [7, 1.8],
      [8, 1.9],
      [9, 2],
      [10, 2.2],
      [11, 2.4],
      [12, 2.6],
      [13, 2.8],
      [14, 3],
      [15, 3.2],
      [16, 3.4]
    ]
  },
  {
    key: 'scenic_platform',
    name: 'Scenic Platform',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'pavilion',
    name: 'Pavilion',
    type: 'simple',
    statNames: ['Archer and mage attack'],
    maxLevel: 21,
    levels: [
      [4, 1.8],
      [5, 2],
      [6, 2.2],
      [7, 2.5],
      [8, 2.8],
      [9, 3.1],
      [10, 3.4],
      [11, 3.7],
      [12, 4],
      [13, 4.3],
      [14, 4.6],
      [15, 5],
      [16, 5.4],
      [17, 5.8],
      [18, 6.2],
      [19, 6.6],
      [20, 7],
      [21, 7.4],
      [22, 7.8],
      [23, 8.2],
      [24, 8.6]
    ]
  },
  {
    key: 'crystal_light',
    name: 'Crystal Light',
    type: 'simple',
    statNames: ['Load boost'],
    maxLevel: 3,
    levels: [
      [1, 1],
      [2, 1.4],
      [3, 1.8]
    ]
  },
  {
    key: 'fountain',
    name: 'Fountain',
    type: 'simple',
    statNames: ['Gather speed boost'],
    maxLevel: 3,
    levels: [
      [1, 1],
      [2, 1.4],
      [3, 1.8]
    ]
  }
]

export const gardenDecorationSets = [
  {
    key: 'candy_factory',
    name: 'Candy Factory',
    items: ['Candy production line', 'Tricky puppet', 'Neon ligts', 'Candy jar', 'Candy courier'],
    statNames: [
      'Enemy troops attack reduction',
      'Angel HP',
      'Archers and mages attack',
      'Infantry and cavalry HP',
      'Attack boost',
      'Cross-Realm Army Size Boost'
    ],
    maxLevel: 15,
    levels: [
      [1, 1.3, 2, 2, 1.3, 2, 200],
      [2, 1.9, 3, 3, 1.9, 3, 350],
      [3, 2.5, 4, 4, 2.5, 4, 500],
      [4, 3.1, 5, 5, 3.1, 5, 650],
      [5, 3.7, 6, 6, 3.7, 6, 800],
      [6, 4.3, 7, 7, 4.3, 7, 950],
      [7, 4.9, 8, 8, 4.9, 8, 1100],
      [8, 5.5, 9, 9, 5.5, 9, 1250],
      [9, 6.1, 10, 10, 6.1, 10, 1400],
      [10, 6.7, 11, 11, 6.7, 11, 1550],
      [11, 7.3, 12, 12, 7.3, 12, 1700],
      [12, 7.9, 13, 13, 7.9, 13, 1850],
      [13, 8.5, 14, 14, 8.5, 14, 2000],
      [14, 9.1, 15, 15, 9.1, 15, 2150],
      [15, 9.7, 16, 16, 9.7, 16, 2300]
    ]
  },
  {
    key: 'food_festival',
    name: 'Food Festival',
    items: ['Refreshing water bar', 'Popcorn', 'Boiling hot pot', 'Tasty pasta', 'Burrito'],
    statNames: [
      'Enemy troops attack reduction',
      'Angel HP',
      'Infantry and cavalry HP',
      'Attack boost',
      'Archers and mages attack',
      'Cross-Realm Army Size Boost'
    ],
    maxLevel: 15,
    levels: [
      [1, 1.3, 2, 2, 1.3, 2, 200],
      [2, 1.9, 3, 3, 1.9, 3, 350],
      [3, 2.5, 4, 4, 2.5, 4, 500],
      [4, 3.1, 5, 5, 3.1, 5, 650],
      [5, 3.7, 6, 6, 3.7, 6, 800],
      [6, 4.3, 7, 7, 4.3, 7, 950],
      [7, 4.9, 8, 8, 4.9, 8, 1100],
      [8, 5.5, 9, 9, 5.5, 9, 1250],
      [9, 6.1, 10, 10, 6.1, 10, 1400],
      [10, 6.7, 11, 11, 6.7, 11, 1550],
      [11, 7.3, 12, 12, 7.3, 12, 1700],
      [12, 7.9, 13, 13, 7.9, 13, 1850],
      [13, 8.5, 14, 14, 8.5, 14, 2000],
      [14, 9.1, 15, 15, 9.1, 15, 2150],
      [15, 9.7, 16, 16, 9.7, 16, 2300]
    ]
  },
  {
    key: 'joyful_gala',
    name: 'Joyful Gala',
    items: ['Hot air ballon', 'Big gate', 'Celebration square', 'Parade float', 'Ferris wheel'],
    statNames: [
      'Archers and mages attack',
      'HP boost',
      'Infantry and cavalry HP',
      'Angel attack',
      'Enemy troops hp reduction',
      'Cross-Realm Army Size Boost'
    ],
    maxLevel: 15,
    levels: [
      [1, 1.3, 2, 2, 1.3, 2, 200],
      [2, 1.9, 3, 3, 1.9, 3, 350],
      [3, 2.5, 4, 4, 2.5, 4, 500],
      [4, 3.1, 5, 5, 3.1, 5, 650],
      [5, 3.7, 6, 6, 3.7, 6, 800],
      [6, 4.3, 7, 7, 4.3, 7, 950],
      [7, 4.9, 8, 8, 4.9, 8, 1100],
      [8, 5.5, 9, 9, 5.5, 9, 1250],
      [9, 6.1, 10, 10, 6.1, 10, 1400],
      [10, 6.7, 11, 11, 6.7, 11, 1550],
      [11, 7.3, 12, 12, 7.3, 12, 1700],
      [12, 7.9, 13, 13, 7.9, 13, 1850],
      [13, 8.5, 14, 14, 8.5, 14, 2000],
      [14, 9.1, 15, 15, 9.1, 15, 2150],
      [15, 9.7, 16, 16, 9.7, 16, 2300]
    ]
  },
  {
    key: 'sea_world',
    name: 'Sea World',
    items: ['Pearl box', 'Mermaid', 'Aquarium', 'Fantasy jellyfish', 'Sea singer'],
    statNames: [
      'Enemy troops HP reduction',
      'Angel attack',
      'Infantry and cavalry HP boost',
      'HP boost',
      'Archers and mages attack',
      'Cross-Realm Army Size Boost'
    ],
    maxLevel: 15,
    levels: [
      [1, 1.3, 2, 2, 1.3, 2, 200],
      [2, 1.9, 3, 3, 1.9, 3, 350],
      [3, 2.5, 4, 4, 2.5, 4, 500],
      [4, 3.1, 5, 5, 3.1, 5, 650],
      [5, 3.7, 6, 6, 3.7, 6, 800],
      [6, 4.3, 7, 7, 4.3, 7, 950],
      [7, 4.9, 8, 8, 4.9, 8, 1100],
      [8, 5.5, 9, 9, 5.5, 9, 1250],
      [9, 6.1, 10, 10, 6.1, 10, 1400],
      [10, 6.7, 11, 11, 6.7, 11, 1550],
      [11, 7.3, 12, 12, 7.3, 12, 1700],
      [12, 7.9, 13, 13, 7.9, 13, 1850],
      [13, 8.5, 14, 14, 8.5, 14, 2000],
      [14, 9.1, 15, 15, 9.1, 15, 2150],
      [15, 9.7, 16, 16, 9.7, 16, 2300]
    ]
  },
  {
    key: 'christmas_eve',
    name: 'Christmas Eve',
    items: ['Canvas tent', 'Bonfire', 'Bonfire camp', 'Reindeer', 'Santa claus'],
    statNames: [
      'Enemy tooprs attack reduction',
      'Infantry and cavalry HP',
      'Archers and mages attack',
      'Angel HP',
      'Attack boost',
      'Cross-Realm Army Size Boost'
    ],
    maxLevel: 15,
    levels: [
      [1, 1.3, 2, 2, 1.3, 2, 200],
      [2, 1.9, 3, 3, 1.9, 3, 350],
      [3, 2.5, 4, 4, 2.5, 4, 500],
      [4, 3.1, 5, 5, 3.1, 5, 650],
      [5, 3.7, 6, 6, 3.7, 6, 800],
      [6, 4.3, 7, 7, 4.3, 7, 950],
      [7, 4.9, 8, 8, 4.9, 8, 1100],
      [8, 5.5, 9, 9, 5.5, 9, 1250],
      [9, 6.1, 10, 10, 6.1, 10, 1400],
      [10, 6.7, 11, 11, 6.7, 11, 1550],
      [11, 7.3, 12, 12, 7.3, 12, 1700],
      [12, 7.9, 13, 13, 7.9, 13, 1850],
      [13, 8.5, 14, 14, 8.5, 14, 2000],
      [14, 9.1, 15, 15, 9.1, 15, 2150],
      [15, 9.7, 16, 16, 9.7, 16, 2300]
    ]
  }
]

export const gardenStatues = [
  {
    key: 'horus',
    name: 'Horus',
    type: 'god_of_war',
    statNames: ['Fragments', 'Infantry and Cavalry HP Boost', 'Angel Damage', 'Divine Eye'],
    maxLevel: 56,
    levels: [
      [1, 10, 1, null, null],
      [2, 10, 1.7, null, null],
      [3, 10, 2.4, null, null],
      [4, 15, 3.1, null, null],
      [5, 20, 3.8, null, null],
      [6, 25, 4.5, null, null],
      [7, 30, 5.2, null, null],
      [8, 35, 5.9, null, null],
      [9, 40, 6.6, null, null],
      [10, 45, 7.3, null, null],
      [11, 50, 7.7, 0.5, null],
      [12, 60, 8.1, 0.8, null],
      [13, 75, 8.5, 1.1, null],
      [14, 90, 8.9, 1.4, null],
      [15, 105, 9.3, 1.7, null],
      [16, 120, 9.7, 2, null],
      [17, 135, 10.1, 2.3, null],
      [18, 150, 10.5, 2.6, null],
      [19, 165, 10.9, 2.9, null],
      [20, 180, 11.3, 3.2, null],
      [21, 200, 11.4, 3.3, 0.7],
      [22, 240, 11.5, 3.4, 1.1],
      [23, 280, 11.6, 3.5, 1.5],
      [24, 320, 11.7, 3.6, 1.9],
      [25, 360, 11.8, 3.7, 2.3],
      [26, 400, 11.9, 3.8, 2.7],
      [27, 420, 12, 3.9, 3.1],
      [28, 420, 12.1, 4, 3.5],
      [29, 420, 12.2, 4.1, 3.9],
      [30, 420, 12.3, 4.2, 4.3],
      [31, 420, 12.4, 4.3, 4.7],
      [32, 420, 12.5, 4.4, 5.1],
      [33, 420, 12.6, 4.5, 5.5],
      [34, 420, 12.7, 4.6, 5.9],
      [35, 420, 12.8, 4.7, 6.3],
      [36, 420, 12.9, 4.8, 6.7],
      [37, 420, 13, 4.9, 7.1],
      [38, 420, 13.1, 5, 7.5],
      [39, 420, 13.2, 5.1, 7.9],
      [40, 420, 13.3, 5.2, 8.3],
      [41, 420, 13.4, 5.3, 8.7],
      [42, 420, 13.5, 5.4, 9.1],
      [43, 420, 13.6, 5.5, 9.5],
      [44, 420, 13.7, 5.6, 9.9],
      [45, 420, 13.8, 5.7, 10.3],
      [46, 420, 13.9, 5.8, 10.7],
      [47, 420, 14, 5.9, 11.1],
      [48, 420, 14.1, 6, 11.5],
      [49, 420, 14.2, 6.1, 11.9],
      [50, 420, 14.3, 6.2, 12.3],
      [51, 420, 14.4, 6.3, 12.7],
      [52, 420, 14.5, 6.4, 13.1],
      [53, 420, 14.6, 6.5, 13.5],
      [54, 420, 14.7, 6.6, 13.9],
      [55, 420, 14.8, 6.7, 14.3],
      [56, 420, 14.9, 6.8, 14.7]
    ]
  },
  {
    key: 'ares',
    name: 'Ares',
    type: 'god_of_war',
    statNames: ['Fragments', 'Archers and Mages Attack', 'Infantry and Cavalry Damage Taken Reduction', 'Fury Force'],
    maxLevel: 56,
    levels: [
      [1, 10, 1, null, null],
      [2, 10, 1.7, null, null],
      [3, 10, 2.4, null, null],
      [4, 15, 3.1, null, null],
      [5, 20, 3.8, null, null],
      [6, 25, 4.5, null, null],
      [7, 30, 5.2, null, null],
      [8, 35, 5.9, null, null],
      [9, 40, 6.6, null, null],
      [10, 45, 7.3, null, null],
      [11, 50, 7.7, 0.5, null],
      [12, 60, 8.1, 0.8, null],
      [13, 75, 8.5, 1.1, null],
      [14, 90, 8.9, 1.4, null],
      [15, 105, 9.3, 1.7, null],
      [16, 120, 9.7, 2, null],
      [17, 135, 10.1, 2.3, null],
      [18, 150, 10.5, 2.6, null],
      [19, 165, 10.9, 2.9, null],
      [20, 180, 11.3, 3.2, null],
      [21, 200, 11.4, 3.3, 1.4],
      [22, 240, 11.5, 3.4, 2.2],
      [23, 280, 11.6, 3.5, 3],
      [24, 320, 11.7, 3.6, 3.8],
      [25, 360, 11.8, 3.7, 4.6],
      [26, 400, 11.9, 3.8, 5.4],
      [27, 420, 12, 3.9, 6.2],
      [28, 420, 12.1, 4, 7],
      [29, 420, 12.2, 4.1, 7.8],
      [30, 420, 12.3, 4.2, 8.6],
      [31, 420, 12.4, 4.3, 9.4],
      [32, 420, 12.5, 4.4, 10.2],
      [33, 420, 12.6, 4.5, 11],
      [34, 420, 12.7, 4.6, 11.8],
      [35, 420, 12.8, 4.7, 12.6],
      [36, 420, 12.9, 4.8, 13.4],
      [37, 420, 13, 4.9, 14.2],
      [38, 420, 13.1, 5, 15],
      [39, 420, 13.2, 5.1, 15.8],
      [40, 420, 13.3, 5.2, 16.6],
      [41, 420, 13.4, 5.3, 17.4],
      [42, 420, 13.5, 5.4, 18.2],
      [43, 420, 13.6, 5.5, 19],
      [44, 420, 13.7, 5.6, 19.8],
      [45, 420, 13.8, 5.7, 20.6],
      [46, 420, 13.9, 5.8, 21.4],
      [47, 420, 14, 5.9, 22.2],
      [48, 420, 14.1, 6, 23],
      [49, 420, 14.2, 6.1, 23.8],
      [50, 420, 14.3, 6.2, 24.6],
      [51, 420, 14.4, 6.3, 25.4],
      [52, 420, 14.5, 6.4, 26.2],
      [53, 420, 14.6, 6.5, 27],
      [54, 420, 14.7, 6.6, 27.8],
      [55, 420, 14.8, 6.7, 28.6],
      [56, 420, 14.9, 6.8, 29.4]
    ]
  },
  {
    key: 'athena',
    name: 'Athena',
    type: 'god_of_war',
    statNames: ['Fragments', 'Infantry and Cavalry HP Boost', 'Archers and Mages Damage Dealt Boost', 'Pallas Armor'],
    maxLevel: 56,
    levels: [
      [1, 10, 1, null, null],
      [2, 10, 1.7, null, null],
      [3, 10, 2.4, null, null],
      [4, 15, 3.1, null, null],
      [5, 20, 3.8, null, null],
      [6, 25, 4.5, null, null],
      [7, 30, 5.2, null, null],
      [8, 35, 5.9, null, null],
      [9, 40, 6.6, null, null],
      [10, 45, 7.3, null, null],
      [11, 50, 7.7, 0.5, null],
      [12, 60, 8.1, 0.8, null],
      [13, 75, 8.5, 1.1, null],
      [14, 90, 8.9, 1.4, null],
      [15, 105, 9.3, 1.7, null],
      [16, 120, 9.7, 2, null],
      [17, 135, 10.1, 2.3, null],
      [18, 150, 10.5, 2.6, null],
      [19, 165, 10.9, 2.9, null],
      [20, 180, 11.3, 3.2, null],
      [21, 200, 11.4, 3.3, 1.4],
      [22, 240, 11.5, 3.4, 2.2],
      [23, 280, 11.6, 3.5, 3],
      [24, 320, 11.7, 3.6, 3.8],
      [25, 360, 11.8, 3.7, 4.6],
      [26, 400, 11.9, 3.8, 5.4],
      [27, 420, 12, 3.9, 6.2],
      [28, 420, 12.1, 4, 7],
      [29, 420, 12.2, 4.1, 7.8],
      [30, 420, 12.3, 4.2, 8.6],
      [31, 420, 12.4, 4.3, 9.4],
      [32, 420, 12.5, 4.4, 10.2],
      [33, 420, 12.6, 4.5, 11],
      [34, 420, 12.7, 4.6, 11.8],
      [35, 420, 12.8, 4.7, 12.6],
      [36, 420, 12.9, 4.8, 13.4],
      [37, 420, 13, 4.9, 14.2],
      [38, 420, 13.1, 5, 15],
      [39, 420, 13.2, 5.1, 15.8],
      [40, 420, 13.3, 5.2, 16.6],
      [41, 420, 13.4, 5.3, 17.4],
      [42, 420, 13.5, 5.4, 18.2],
      [43, 420, 13.6, 5.5, 19],
      [44, 420, 13.7, 5.6, 19.8],
      [45, 420, 13.8, 5.7, 20.6],
      [46, 420, 13.9, 5.8, 21.4],
      [47, 420, 14, 5.9, 22.2],
      [48, 420, 14.1, 6, 23],
      [49, 420, 14.2, 6.1, 23.8],
      [50, 420, 14.3, 6.2, 24.6],
      [51, 420, 14.4, 6.3, 25.4],
      [52, 420, 14.5, 6.4, 26.2],
      [53, 420, 14.6, 6.5, 27],
      [54, 420, 14.7, 6.6, 27.8],
      [55, 420, 14.8, 6.7, 28.6],
      [56, 420, 14.9, 6.8, 29.4]
    ]
  },
  {
    key: 'behemoth',
    name: 'Behemoth',
    type: 'monster',
    statNames: ['Fragments', 'Archers and Mages Attack', 'Infantry and Cavalry Damage Taken Reduction'],
    maxLevel: 56,
    levels: [
      [1, 5, 1, null],
      [2, 8, 1.6, null],
      [3, 11, 2.2, null],
      [4, 14, 2.8, null],
      [5, 17, 3.4, null],
      [6, 20, 4, null],
      [7, 24, 4.6, null],
      [8, 28, 5.2, null],
      [9, 32, 5.8, null],
      [10, 40, 6.4, null],
      [11, 48, 6.7, 0.4],
      [12, 60, 7, 0.6],
      [13, 72, 7.3, 0.8],
      [14, 84, 7.6, 1],
      [15, 96, 7.9, 1.2],
      [16, 114, 8.2, 1.4],
      [17, 132, 8.5, 1.6],
      [18, 150, 8.8, 1.8],
      [19, 168, 9.1, 2],
      [20, 186, 9.4, 2.2],
      [21, 210, 9.7, 2.4],
      [22, 234, 10, 2.6],
      [23, 258, 10.3, 2.8],
      [24, 282, 10.6, 3],
      [25, 306, 10.9, 3.2],
      [26, 330, 11.2, 3.4],
      [27, 354, 11.5, 3.6],
      [28, 378, 11.8, 3.8],
      [29, 402, 12.1, 4],
      [30, 420, 12.4, 4.2],
      [31, 420, 12.7, 4.4],
      [32, 420, 13, 4.6],
      [33, 420, 13.3, 4.8],
      [34, 420, 13.6, 5],
      [35, 420, 13.9, 5.2],
      [36, 420, 14.2, 5.4],
      [37, 420, 14.5, 5.6],
      [38, 420, 14.8, 5.8],
      [39, 420, 15.1, 6],
      [40, 420, 15.4, 6.2],
      [41, 420, 15.7, 6.4],
      [42, 420, 16, 6.6],
      [43, 420, 16.3, 6.8],
      [44, 420, 16.6, 7],
      [45, 420, 16.9, 7.2],
      [46, 420, 17.2, 7.4],
      [47, 420, 17.5, 7.6],
      [48, 420, 17.8, 7.8],
      [49, 420, 18.1, 8],
      [50, 420, 18.4, 8.2],
      [51, 420, 18.7, 8.4],
      [52, 420, 19, 8.6],
      [53, 420, 19.3, 8.8],
      [54, 420, 19.6, 9],
      [55, 420, 19.9, 9.2],
      [56, 420, 20.2, 9.4]
    ]
  },
  {
    key: 'red_dragon',
    name: 'Red Dragon',
    type: 'monster',
    statNames: ['Fragments', 'Archers and Mages Attack', 'Infantry and Cavalry Damage Taken Reduction'],
    maxLevel: 56,
    levels: [
      [1, 5, 1, null],
      [2, 8, 1.6, null],
      [3, 11, 2.2, null],
      [4, 14, 2.8, null],
      [5, 17, 3.4, null],
      [6, 20, 4, null],
      [7, 24, 4.6, null],
      [8, 28, 5.2, null],
      [9, 32, 5.8, null],
      [10, 40, 6.4, null],
      [11, 48, 6.7, 0.4],
      [12, 60, 7, 0.6],
      [13, 72, 7.3, 0.8],
      [14, 84, 7.6, 1],
      [15, 96, 7.9, 1.2],
      [16, 114, 8.2, 1.4],
      [17, 132, 8.5, 1.6],
      [18, 150, 8.8, 1.8],
      [19, 168, 9.1, 2],
      [20, 186, 9.4, 2.2],
      [21, 210, 9.7, 2.4],
      [22, 234, 10, 2.6],
      [23, 258, 10.3, 2.8],
      [24, 282, 10.6, 3],
      [25, 306, 10.9, 3.2],
      [26, 330, 11.2, 3.4],
      [27, 354, 11.5, 3.6],
      [28, 378, 11.8, 3.8],
      [29, 402, 12.1, 4],
      [30, 420, 12.4, 4.2],
      [31, 420, 12.7, 4.4],
      [32, 420, 13, 4.6],
      [33, 420, 13.3, 4.8],
      [34, 420, 13.6, 5],
      [35, 420, 13.9, 5.2],
      [36, 420, 14.2, 5.4],
      [37, 420, 14.5, 5.6],
      [38, 420, 14.8, 5.8],
      [39, 420, 15.1, 6],
      [40, 420, 15.4, 6.2],
      [41, 420, 15.7, 6.4],
      [42, 420, 16, 6.6],
      [43, 420, 16.3, 6.8],
      [44, 420, 16.6, 7],
      [45, 420, 16.9, 7.2],
      [46, 420, 17.2, 7.4],
      [47, 420, 17.5, 7.6],
      [48, 420, 17.8, 7.8],
      [49, 420, 18.1, 8],
      [50, 420, 18.4, 8.2],
      [51, 420, 18.7, 8.4],
      [52, 420, 19, 8.6],
      [53, 420, 19.3, 8.8],
      [54, 420, 19.6, 9],
      [55, 420, 19.9, 9.2],
      [56, 420, 20.2, 9.4]
    ]
  },
  {
    key: 'tri_head_dog',
    name: 'Tri-head Dog',
    type: 'monster',
    statNames: ['Fragments', 'Archers and Mages Attack', 'Infantry and Cavalry Damage Taken Reduction'],
    maxLevel: 56,
    levels: [
      [1, 5, 1, null],
      [2, 8, 1.6, null],
      [3, 11, 2.2, null],
      [4, 14, 2.8, null],
      [5, 17, 3.4, null],
      [6, 20, 4, null],
      [7, 24, 4.6, null],
      [8, 28, 5.2, null],
      [9, 32, 5.8, null],
      [10, 40, 6.4, null],
      [11, 48, 6.7, 0.4],
      [12, 60, 7, 0.6],
      [13, 72, 7.3, 0.8],
      [14, 84, 7.6, 1],
      [15, 96, 7.9, 1.2],
      [16, 114, 8.2, 1.4],
      [17, 132, 8.5, 1.6],
      [18, 150, 8.8, 1.8],
      [19, 168, 9.1, 2],
      [20, 186, 9.4, 2.2],
      [21, 210, 9.7, 2.4],
      [22, 234, 10, 2.6],
      [23, 258, 10.3, 2.8],
      [24, 282, 10.6, 3],
      [25, 306, 10.9, 3.2],
      [26, 330, 11.2, 3.4],
      [27, 354, 11.5, 3.6],
      [28, 378, 11.8, 3.8],
      [29, 402, 12.1, 4],
      [30, 420, 12.4, 4.2],
      [31, 420, 12.7, 4.4],
      [32, 420, 13, 4.6],
      [33, 420, 13.3, 4.8],
      [34, 420, 13.6, 5],
      [35, 420, 13.9, 5.2],
      [36, 420, 14.2, 5.4],
      [37, 420, 14.5, 5.6],
      [38, 420, 14.8, 5.8],
      [39, 420, 15.1, 6],
      [40, 420, 15.4, 6.2],
      [41, 420, 15.7, 6.4],
      [42, 420, 16, 6.6],
      [43, 420, 16.3, 6.8],
      [44, 420, 16.6, 7],
      [45, 420, 16.9, 7.2],
      [46, 420, 17.2, 7.4],
      [47, 420, 17.5, 7.6],
      [48, 420, 17.8, 7.8],
      [49, 420, 18.1, 8],
      [50, 420, 18.4, 8.2],
      [51, 420, 18.7, 8.4],
      [52, 420, 19, 8.6],
      [53, 420, 19.3, 8.8],
      [54, 420, 19.6, 9],
      [55, 420, 19.9, 9.2],
      [56, 420, 20.2, 9.4]
    ]
  }
]

export const gardenBeastSkins = [
  {
    key: 'regular',
    name: 'Regular',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Special'],
    maxLevel: 20,
    levels: [
      [1, 50, 3.2, 2.6, null],
      [2, 20, 3.7, 2.6, null],
      [3, 30, 3.7, 2.9, null],
      [4, 40, 4.2, 2.9, null],
      [5, 50, 4.2, 3.2, 10],
      [6, 60, 4.7, 3.2, 10],
      [7, 70, 4.7, 3.5, 10],
      [8, 80, 5.2, 3.5, 10],
      [9, 90, 5.2, 3.8, 10],
      [10, 100, 5.7, 3.8, 20],
      [11, 110, 5.7, 4.1, 20],
      [12, 120, 6.2, 4.1, 20],
      [13, 130, 6.2, 4.4, 20],
      [14, 140, 6.7, 4.4, 20],
      [15, 150, 6.7, 4.7, 40],
      [16, 160, 7.2, 4.7, 40],
      [17, 170, 7.2, 5, 40],
      [18, 180, 7.7, 5, 40],
      [19, null, 7.7, 5.3, 40],
      [20, null, 8.2, 5.3, 40]
    ]
  },
  {
    key: 'ice',
    name: 'Ice',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Special'],
    maxLevel: 20,
    levels: [
      [1, 50, 2.6, 3.2, null],
      [2, 20, 2.6, 3.7, null],
      [3, 30, 2.9, 3.7, null],
      [4, null, 2.9, 4.2, null],
      [5, null, 3.2, 4.2, 5],
      [6, null, 3.2, 4.7, 5],
      [7, 80, 3.5, 4.7, 5],
      [8, 80, 3.5, 5.2, 5],
      [9, null, 3.8, 5.2, 5],
      [10, null, 3.8, 5.7, 10],
      [11, null, 4.1, 5.7, 10],
      [12, null, 4.1, 6.2, 10],
      [13, null, 4.4, 6.2, 10],
      [14, null, 4.4, 6.7, 10],
      [15, null, 4.7, 6.7, 20],
      [16, 160, 4.7, 7.2, 20],
      [17, 170, 5, 7.2, 20],
      [18, null, 5, 7.7, 20],
      [19, null, 5.3, 7.7, 20],
      [20, null, 5.3, 8.2, 20]
    ]
  },
  {
    key: 'dark_star',
    name: 'Dark Star',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Special'],
    maxLevel: 20,
    levels: [
      [1, 80, 2.2, 300, null],
      [2, 80, 2.5, 300, '4 / 4'],
      [3, 80, 2.5, 450, '4 / 4'],
      [4, 80, 2.8, 450, '5.4 / 5.5'],
      [5, 100, 2.8, 600, '5.4 / 5.5'],
      [6, null, 3.3, 600, '6.8 / 7'],
      [7, null, 3.3, 750, '6.8 / 7'],
      [8, null, 3.8, 750, '8.4 / 8.5'],
      [9, null, 3.8, 900, '8.4 / 8.5'],
      [10, null, 4.3, 900, '10.2 / 10'],
      [11, null, 4.3, 1050, '10.2 / 10'],
      [12, 260, 4.9, 1050, '12 / 12'],
      [13, null, 4.9, 1200, '12 / 12'],
      [14, null, 5.4, 1200, '14 / 14'],
      [15, null, 5.4, 1400, '14 / 14'],
      [16, 600, 6, 1400, '16.4 / 16'],
      [17, null, null, null, null],
      [18, null, null, null, null],
      [19, null, null, null, null],
      [20, null, null, null, null]
    ]
  },
  {
    key: 'dessert',
    name: 'Dessert',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Special'],
    maxLevel: 20,
    levels: [
      [1, 80, 2.2, 600, null],
      [2, 80, 2.5, 600, '4 / 4'],
      [3, 80, 2.5, 900, '4 / 4'],
      [4, 80, 2.8, 900, '5.4 / 5.4'],
      [5, 100, 2.8, 1200, '5.4 / 5.4'],
      [6, null, 3.3, 1200, '6.8 / 6.8'],
      [7, null, 3.3, 1500, '6.8 / 6.8'],
      [8, null, 3.8, 1500, '8.4 / 8.4'],
      [9, null, 3.8, 1800, '8.4 / 8.4'],
      [10, null, 4.3, 1800, '10.2 / 10.2'],
      [11, null, 4.3, 2100, '10.2 / 10.2'],
      [12, null, 4.9, 2100, '12 / 12'],
      [13, 320, 4.9, 2400, '12 / 12'],
      [14, null, 5.4, 2400, '14 / 14'],
      [15, 500, 5.4, 2800, '14 / 14'],
      [16, null, 6, 2800, '16.4 / 16.4'],
      [17, null, null, null, null],
      [18, null, null, null, null],
      [19, null, null, null, null],
      [20, null, null, null, null]
    ]
  },
  {
    key: 'mecha',
    name: 'Mecha',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Special'],
    maxLevel: 20,
    levels: [
      [1, 80, 2.2, 720, null],
      [2, 60, 2.5, 720, '4 / 3'],
      [3, 80, 2.5, 1080, '4 / 3'],
      [4, 80, 2.8, 1080, '5,4 . 4'],
      [5, 100, 2.8, 1440, '5.4 / 4'],
      [6, null, 3.3, 1440, '6.8 / 5'],
      [7, null, 3.3, 1800, '6.8 / 5'],
      [8, null, 3.8, 1800, '8.4 / 6.1'],
      [9, null, 3.8, 2160, '8.4 / 6.1'],
      [10, 140, 4.3, 2160, '10.2 / 7.4'],
      [11, null, 4.3, 2520, '10.2 / 7.4'],
      [12, 260, 4.9, 2520, '12 / 8.7'],
      [13, null, 4.9, 2880, '12 / 8.7'],
      [14, null, 5.4, 2880, '14 / 10.1'],
      [15, null, 5.4, 3360, '14 / 10.1'],
      [16, null, 6, 3360, '16.4 / 11.8'],
      [17, null, null, null, null],
      [18, null, null, null, null],
      [19, null, null, null, null],
      [20, null, null, null, null]
    ]
  },
  {
    key: 'dracula',
    name: 'Dracula',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Special'],
    maxLevel: 20,
    levels: [
      [1, 80, 2.2, 600, null],
      [2, 60, 2.5, 600, '6.4 / 4 / 1'],
      [3, 70, 2.5, 900, '6.4 / 4 / 1'],
      [4, 80, 2.8, 900, '8.5 / 5.4 / 1.3'],
      [5, 90, 2.8, 1200, '8.5 / 5.4 / 1.3'],
      [6, 100, 3.3, 1200, '11.1 / 6.8 / 1.6'],
      [7, 110, 3.3, 1500, '11.1 / 6.8 / 1.6'],
      [8, 120, 3.8, 1500, '13.6 / 8.4 / 1.9'],
      [9, null, 3.8, 1800, '13.6 / 8.4 / 1.9'],
      [10, null, 4.3, 1800, '16.4 / 10.2 / 2.2'],
      [11, null, 4.3, 2100, '16.4 / 10.2 / 2.2'],
      [12, null, 4.9, 2100, '19.3 / 12 / 2.5'],
      [13, null, 4.9, 2400, '19.3 / 12 / 2.5'],
      [14, null, 5.4, 2400, '22.9 / 14 / 2.8 '],
      [15, null, 5.4, 2800, '22.9 / 14 / 2.8 '],
      [16, null, 6, 2800, '26.5 / 16.4 / 3.1'],
      [17, null, null, null, null],
      [18, null, null, null, null],
      [19, null, null, null, null],
      [20, null, null, null, null]
    ]
  }
]

export const gardenIllusions = [
  {
    key: 'floating_whale',
    name: 'Floating Whale',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Skill 3'],
    maxLevel: 40,
    levels: [
      [1, 24, 3.5, 6, null],
      [2, null, 3.5, 7, null],
      [3, null, 3.5, 8, null],
      [4, 5, 3.5, 9, null],
      [5, 5, 3.5, 16, 1.2],
      [6, null, 3.5, 17, 2.2],
      [7, null, 3.5, 18, 3.2],
      [8, null, 3.5, 19, 4.2],
      [9, null, 3.5, 20, 5.2],
      [10, null, 3.5, 21, 6.2],
      [11, null, 3.5, 22, 7.2],
      [12, null, 3.5, 23, 8.2],
      [13, null, 3.5, 24, 9.2],
      [14, null, 3.5, 25, 10.2],
      [15, null, 3.5, 26, 11.2],
      [16, null, 3.5, 27, 12.2],
      [17, null, 3.5, 28, 13.2],
      [18, null, 3.5, 29, 14.2],
      [19, null, 3.5, 30, 15.2],
      [20, null, 3.5, 31, 16.2],
      [21, null, 3.5, 32, 17.2],
      [22, 18, 3.5, 33, 18.2],
      [23, 20, 3.5, 34, 19.2],
      [24, 22, 3.5, 35, 20.2],
      [25, 24, 3.5, 36, 21.2],
      [26, 26, 3.5, 37, 22.2],
      [27, 28, 3.5, 38, 23.2],
      [28, 30, 3.5, 39, 24.2],
      [29, null, 3.5, 40, 25.2],
      [30, null, 3.5, 41, 26.2],
      [31, null, null, null, null],
      [32, null, null, null, null],
      [33, null, null, null, null],
      [34, null, null, null, null],
      [35, null, null, null, null],
      [36, null, null, null, null],
      [37, null, null, null, null],
      [38, null, null, null, null],
      [39, null, null, null, null],
      [40, null, null, null, null]
    ]
  },
  {
    key: 'mistwing_dragon',
    name: 'Mistwing Dragon',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Skill 3'],
    maxLevel: 40,
    levels: [
      [1, 20, 4, 6, null],
      [2, null, 4, 7, null],
      [3, null, 4, 8, null],
      [4, 4, 4, 10, null],
      [5, null, 4, 11, 1.2],
      [6, null, 4, 12, 2],
      [7, 5, 4, 13, 2.8],
      [8, 6, 4, 14, 3.6],
      [9, 6, 4, 15, 4.4],
      [10, null, 4, 16, 5.2],
      [11, null, 4, 17, 6],
      [12, null, 4, 18, 6.8],
      [13, null, 4, 19, 7.6],
      [14, null, 4, 20, 8.4],
      [15, null, 4, 21, 9.2],
      [16, null, 4, 22, 10],
      [17, null, 4, 23, 10.8],
      [18, null, 4, 24, 11.6],
      [19, null, 4, 25, 12.4],
      [20, null, 4, 26, 13.2],
      [21, null, 4, 27, 14],
      [22, null, 4, 28, 14.8],
      [23, null, 4, 29, 15.6],
      [24, null, 4, 30, 16.4],
      [25, null, 4, 31, 17.2],
      [26, null, 4, 32, 18],
      [27, null, 4, 33, 18.8],
      [28, 26, 4, 34, 19.6],
      [29, null, 4, 35, 20.4],
      [30, null, 4, 36, 21.2],
      [31, null, 4, 37, 22],
      [32, null, 4, 38, 22.8],
      [33, 30, 4, 39, 23.6],
      [34, null, null, null, null],
      [35, null, null, null, null],
      [36, null, null, null, null],
      [37, null, null, null, null],
      [38, null, null, null, null],
      [39, null, null, null, null],
      [40, null, null, null, null]
    ]
  },
  {
    key: 'shimmering_jellyfish',
    name: 'Shimmering Jellyfish',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Skill 3'],
    maxLevel: 40,
    levels: [
      [1, 24, 3.5, 6, null],
      [2, null, 3.5, 7, null],
      [3, null, 3.5, 8, null],
      [4, null, 3.5, 9, null],
      [5, null, 3.5, 16, 1.2],
      [6, 6, 3.5, 17, 2.2],
      [7, null, 3.5, 18, 3.2],
      [8, 6, 3.5, 19, 4.2],
      [9, null, 3.5, 20, 5.2],
      [10, null, 3.5, 21, 6.2],
      [11, null, 3.5, 22, 7.2],
      [12, null, 3.5, 23, 8.2],
      [13, null, 3.5, 24, 9.2],
      [14, null, 3.5, 25, 10.2],
      [15, null, 3.5, 26, 11.2],
      [16, null, 3.5, 27, 12.2],
      [17, null, 3.5, 28, 13.2],
      [18, null, 3.5, 29, 14.2],
      [19, null, 3.5, 30, 15.2],
      [20, null, 3.5, 31, 16.2],
      [21, null, 3.5, 32, 17.2],
      [22, null, 3.5, 33, 18.2],
      [23, null, null, null, null],
      [24, null, null, null, null],
      [25, null, null, null, null],
      [26, null, null, null, null],
      [27, null, null, null, null],
      [28, null, null, null, null],
      [29, null, null, null, null],
      [30, null, null, null, null],
      [31, null, null, null, null],
      [32, null, null, null, null],
      [33, null, null, null, null],
      [34, null, null, null, null],
      [35, null, null, null, null],
      [36, null, null, null, null],
      [37, null, null, null, null],
      [38, null, null, null, null],
      [39, null, null, null, null],
      [40, null, null, null, null]
    ]
  },
  {
    key: 'odin',
    name: 'Odin',
    statNames: ['Fragments', 'Skill 1', 'Skill 2', 'Skill 3', 'Skill 4'],
    maxLevel: 40,
    levels: [
      [1, 120, 7, null, null, null],
      [2, null, 7, 9, null, null],
      [3, 25, 7, 12, null, null],
      [4, 25, 7, null, null, null],
      [5, null, 7, 16, 1.2, null],
      [6, null, 7, 17, 2.4, null],
      [7, 30, 7, 18, 3.6, null],
      [8, null, 7, 19, 4.8, null],
      [9, null, 7, 20, 6, null],
      [10, null, 7, 21, 7.2, null],
      [11, null, 7, 22, 8, null],
      [12, null, 7, 23, 9.2, null],
      [13, null, 7, 24, 10.4, null],
      [14, null, 7, 25, 11.6, null],
      [15, null, 7, 26, 12.8, 1.2],
      [16, 60, 7, 27, 13.6, 2.4],
      [17, 60, 7, 28, 14.4, 3.6],
      [18, 60, 7, 29, 15.2, 4.8],
      [19, 60, 7, 30, 16, 5],
      [20, null, 7, 31, 16.8, 7.2],
      [21, null, 7, 32, 17.6, 8.4],
      [22, 75, 7, 33, 18.4, 9.6],
      [23, null, 7, 34, 19.2, 10.8],
      [24, null, 7, 35, 20, 12],
      [25, null, 7, 36, 20.8, 13.2],
      [26, null, 7, 37, 21.6, 14.4],
      [27, null, 7, 38, 22.4, 15.6],
      [28, null, 7, 39, 23.2, 16.8],
      [29, null, 7, 40, 24, 18],
      [30, null, 7, 41, 24.8, 19.2],
      [31, null, null, null, null, null],
      [32, null, null, null, null, null],
      [33, null, null, null, null, null],
      [34, null, null, null, null, null],
      [35, null, null, null, null, null],
      [36, null, null, null, null, null],
      [37, null, null, null, null, null],
      [38, null, null, null, null, null],
      [39, null, null, null, null, null],
      [40, null, null, null, null, null]
    ]
  }
]

export const gardenEvents = {
  Mirage: ['People shopping spree'],
  'Poseidon warship': ['Godess blessing', 'Alliance treasure hunt'],
  'Candy castle': [],
  'Countryside party': ['Sacred dragon prayer', 'Purchases with gifts', 'Pet carnival', 'Fishing tournament'],
  'Love in the city': [],
  'Star collection': [
    'Sacred dragon prayer',
    'Godess blessing',
    'Purchases with gifts',
    'Pet carnival',
    'Fishing tournament'
  ],
  'Leviathan magic bottle': ['Pet carnival'],
  'Christmas tale': [],
  'Dragon guard': ['Sacred dragon prayer', 'Purchases with gifts', 'Pet carnival', 'Fishing tournament'],
  'Phantom playground': ['Godess blessing'],
  'Castle in the sky': ['Sacred dragon prayer', 'Purchases with gifts', 'Pet carnival', 'Fishing tournament'],
  'Dune Pavilion': ['People shopping spree'],
  'Island Adventure': ['Alliance treasure hunt'],
  'Pumpkin cart': ['Pet carnival'],
  'Panda Courtyard': ['Sacred dragon prayer', 'Purchases with gifts'],
  'Pandora box': ['Godess blessing'],
  'Magic house': ['Michael the archangel'],
  'Spring fishing': ['Michael the archangel'],
  'Romantic date': [],
  'Garden cart': ['Sacred dragon prayer', 'Joyful marble', 'Pet carnival'],
  'Christmas carol': [],
  'Exotic charm': ['Sacred dragon prayer', 'Pet carnival'],
  'Griffin guard': ['Sacred dragon prayer', 'Pet carnival'],
  'Desert boat': ['People shopping spree'],
  'Pirate treasure': ['Alliance treasure hunt'],
  'Troublemaking ghost': ['Pet carnival'],
  'Greenery panda': ['Purchases with gifts', 'Joyful marble'],
  'Bay tree': ['Godess blessing'],
  'Rabbit tea cup': ['Michael the archangel'],
  Windmill: [],
  'Cherry tree': [],
  'Midsummer night dreams': ['Sacred dragon prayer'],
  'Christmas tree': [],
  'Scenic Platform': [],
  Pavilion: [],
  'Crystal light': [],
  Fountain: [],
  'Candy factory': [],
  'Food festival': ['Tasty supply station', 'Jester party', 'Michael the archangel', 'Treasure hunt path'],
  'Joyful gala': [],
  'Sea world': ['Tasty supply station', 'Jester party', 'Michael the archangel', 'Treasure hunt path'],
  'Christmas Eve': [],
  Horus: ['War of frontiers'],
  Ares: ['Mini treasure hunt', 'Purchases with gifts'],
  Athena: ['Alliance treasure hunt'],
  Behemoth: ['Mini treasure hunt'],
  'Red dragon': ['Potion workshop'],
  'Tri-head dog': ['Alliance conquest'],
  Regular: ['Sacred dragon prayer', 'Godess blessing', 'Joyful marble'],
  Ice: [],
  'Dark star': ['Sacred dragon prayer', 'Godess blessing', 'Joyful marble'],
  Dessert: ['Sacred dragon prayer', 'Godess blessing', 'Joyful marble', 'Frost monster showdown'],
  Mecha: ['Godess blessing', 'Frost monster showdown'],
  Dracula: ['Pet carnival'],
  'Floating whale': [],
  'Miswing dragon': ['Farplane'],
  'Shimmering jellyfish': ['Joyful marble'],
  Odin: ['Sacred dragon prayer', 'Godess blessing', 'Pet carnival']
}
